import React, { useEffect } from 'react';
import uniqid from 'uniqid';
import { skills } from '../../portfolio';
import './Skills.css';

const Skills = () => {
  useEffect(() => {
    const skillsSections = document.querySelectorAll('.skills__section');
    skillsSections.forEach((section, index) => {
      // Apply animation delay to create staggered effect
      section.style.animationDelay = `${index * 0.1}s`;
      section.classList.add('fade-in');
    });
  }, []);

  if (!skills.length) return null;

  return (
    <section className='section skills' id='skills'>
      <h2 className='section__title'>Skills </h2>

      {skills.map((category) => (
        <div key={uniqid()} className='skills__section'>
          <h3 className='skills__section-title'>{category.category}</h3>
          <ul className='skills__list'>
            {category.skills.map((skill) => (
              <li key={uniqid()} className='skills__list-item btn btn--plain'>
                {skill}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
};

export default Skills;
